'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Skewers = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Skewers, _Component);

  function Skewers() {
    (0, _classCallCheck3.default)(this, Skewers);
    return (0, _possibleConstructorReturn3.default)(this, (Skewers.__proto__ || (0, _getPrototypeOf2.default)(Skewers)).apply(this, arguments));
  }

  (0, _createClass3.default)(Skewers, [{
    key: 'render',
    value: function render() {
      var styles = require('./Recipes.scss');
      var skewerImg = require('./Assets/skewers.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.recipePanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Fantastically Flexible Fruit Skewers'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8 },
              _react2.default.createElement(
                'p',
                null,
                'Fruit skewers are a fun way to get kids in the kitchen and enjoy a variety of fruit. Choose fruits that are soft enough to easily thread skewers through, such as strawberries, grapes, rockmelon, honeydew, watermelon, pineapple, banana, kiwifruit, orange and raspberries. Almost anything goes!'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ingredients:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '3 - 5 different fruits, such as those listed above'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Bamboo skewers [choose small skewers for younger children]'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Instructions:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Thread fruit onto skewers and serve.'
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(ReactBootstrap.Image, { src: skewerImg, responsive: true })
            ),
            _react2.default.createElement(ReactBootstrap.Col, { md: 1 })
          )
        )
      );
    }
  }]);
  return Skewers;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Skewers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Skewers.js
// module id = 1232
// module chunks = 0